import React from 'react';
import { isMobile as getMobileInfo } from '@common/utils/device';

const isMobile = getMobileInfo.any();

const BoardSnsButtons = ({ fileUrl }) => {
  const isExternal = $utils.checkExternal();

  const { info: toastInfo, error: toastError } = $hooks.useToast();

  const sharePost = type => {
    try {
      if (type === 'kakao') {
        if (!isExternal)
          return toastInfo('해당 기능은 외부환경에서만 동작합니다.');

        $utils.shareKakao(fileUrl);
      } else if (type === 'sms') {
        if (!isMobile) return toastInfo('해당 기능은 모바일에서만 동작합니다.');
        $utils.shareSmsMobile(fileUrl);
      }
    } catch (error) {
      toastError(error.message);
    }
  };

  return (
    <>
      <button onClick={() => sharePost('kakao')}>
        <span className="ico ico-kakao-share" />
        카카오톡 공유
      </button>
      <button onClick={() => sharePost('sms')}>
        <span className="ico ico-share" />
        SMS 공유
      </button>
    </>
  );
};

BoardSnsButtons.propTypes = {
  fileUrl: $propTypes.string,
};

BoardSnsButtons.defaultProps = {};

export default BoardSnsButtons;
